<template>
  <div class="flex flex-col c-box">
    <div class="header-box">
      <p class="nowrap" style="width: 90%; margin: 0px auto">
        {{ title }}佐证材料
      </p>
      <div class="close-box" @click="closePreview">x</div>
    </div>
    <div class="centent-box">
      <div class="title-box" v-if="!isEdit">
        <span class="title-text" style="padding: 0px; border: 0px"></span>
        <span class="btn-action-group" v-if="$store.state.role!= 'audit-role'">
          <a-button type="primary" @click="addEvidences" class="btn-action"
            >新增</a-button
          >
          <a-button class="btn-action" danger type="text" @click="batchDelete"
            >批量移除</a-button
          >
        </span>
      </div>
      <a-table
        style="text-align: center; margin: 0px auto"
        :locale="{ emptyText: '暂无数据' }"
        :columns="columns"
        :data-source="dataList"
        :loading="loading"
        @change="handleTableChange"
        :pagination="pagination"
        :bordered="true"
        rowKey="id"
        :row-selection="rowSelection"
      >
        <template slot="sequenceNumber" slot-scope="text, record, index">{{
          index + 1
        }}</template>
        <template slot="fileName" slot-scope="text, record">
          <div
            @click="sbs(record)"
            style="
              color: #e5914b;
              cursor: pointer;
              width: 200px;
              overflow: hidden;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin: 0px auto;
            "
            :title="text"
          >
            {{ text }}
          </div>
        </template>
        <span
          class="flex flex-around"
          slot="action"
          slot-scope="record"
          style="margin: 0 30px"
          v-if="$store.state.role!= 'audit-role'"
        >
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="!isEdit"
            @click="editInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img42.png" alt />
            <span>编辑</span>
          </div>
          <div
            class="flex align-items-center"
            style="cursor: pointer"
            v-if="!isEdit"
            @click="deleteInfo(record)"
          >
            <img class="img-box" src="../../assets/images/img43.png" alt />
            <span>移除</span>
          </div>
        </span>
      </a-table>
    </div>
    <add-evidence ref="addEvidence" @addEvidence="addEvidence"></add-evidence>
    <a-modal
      title="您确定删除吗"
      :visible="showDeleteModel"
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="showDeleteModel = false"
    >
      <p>您确定要删除佐证材料吗?</p>
    </a-modal>
    <div class="preview-pop-box" v-if="showiframe">
      <div class="preview-boxs" style="height: 90%">
        <newpreview
          :previewUrl="previewUrl"
          @closePreview="showiframe = false"
          :sj="sj"
          dialogTitle="佐证材料预览"
        ></newpreview>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, putAction, deleteAction } from "@/api/index";
import addEvidence from "./addEvidence.vue";
import newpreview from "./newpreviews";

const columns = [
  {
    title: "序号",
    dataIndex: "sequenceNumber",
    id: "sequenceNumber",
    align: "center",
    scopedSlots: { customRender: "sequenceNumber" },
    width: 70,
  },
  {
    title: "年份",
    dataIndex: "evidenceYear",
    id: "evidenceYear",
    align: "center",
    width: 100,
  },
  {
    title: "佐证材料",
    dataIndex: "fileName",
    id: "fileName",
    align: "center",
    scopedSlots: { customRender: "fileName" },
    width: 240,
  },
  {
    title: "佐证材料说明",
    dataIndex: "evidenceExplain",
    id: "evidenceExplain",
    align: "center",
    ellipsis: true,
  },
  {
    title: "操作",
    id: "action",
    align: "center",
    width: 204,
    scopedSlots: { customRender: "action" },
  },
];

export default {
  data() {
    return {
      columns: columns,
      dataList: [],
      loading: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 5,
      },
      type: "",
      deteleId: "",
      showDeleteModel: false,
      selectedRowKeys: [],
      showiframe: false,
      previewUrl: "",
      sj:{},
    };
  },
  components: {
    addEvidence,
    newpreview,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    id: {
      type: [String, Number],
      default: "",
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    dataid: {
      type: [String, Number],
      default: "",
    },
    code: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.pagination.current = 1;
    this.columns = columns;
    this.getData();
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        // 其他 row-selection 的配置
      };
    },
  },
  methods: {
    sbs(record) {
      if (
        record.fileName != "" &&
        record.fileName != null &&
        record.fileName != "" &&
        record.fileName != null
      ) {
        this.showiframe = true;
        this.previewUrl = record.filePath;
        console.log(record,"3333");
        this.sj=record;
      } else {
        this.$message.warning("佐证材料暂未上传，请上传后预览");
      }
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    batchDelete() {
      let applyType = 1;
      if (this.$route.name === "szStudio") {
        applyType = 1;
      } else if (this.$route.name === "educationalBrand") {
        applyType = 2;
      } else {
        applyType = 3;
      }
      if (this.selectedRowKeys.length == "0") {
        this.$message.warning("请选择要批量移除的佐证材料");
      } else {
        let params = {
          ids: this.selectedRowKeys.toString(),
        };
        deleteAction("/lxbase/lxApplyEvidence/deleteBatch", params).then(
          (res) => {
            if (res.code == 200) {
              this.$message.success("批量移除成功");
              this.pagination.current = 1;
              this.getData();
              this.selectedRowKeys = [];
              this.$forceUpdate();
            } else {
              this.$message.error(res.message);
            }
          }
        );
      }
    },
    handleOk() {
      deleteAction("/lxbase/lxApplyEvidence/delete", {
        id: this.deteleId,
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success("移除成功");
          this.pagination.current = 1;
          this.showDeleteModel = false;
          this.getData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addEvidence() {
      this.pagination.current = 1;
      this.getData();
    },
    editInfo(row) {
      row.dataId = this.dataid || row.sjId || row.dataId;
      row.code = this.code;
      this.$refs.addEvidence.init("edit", row);
    },
    deleteInfo(row) {
      this.showDeleteModel = true;
      this.deteleId = row.id;
    },
    addEvidences() {
      this.$refs.addEvidence.init("add", {
        id: this.id,
        type: this.type,
        dataId: this.dataid,
        code: this.code,
      });
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getData();
    },
    getData() {
      this.loading = true;
      let type = "";
      if (this.title == "工作室团队" || this.title == "品牌团队") {
        type = "td";
      } else if (this.title == "资金预算" || this.title == "品牌资金预算") {
        type = "ys";
      } else if (this.title == "资金支出" || this.title == "品牌资金使用") {
        type = "zc";
      } else if (this.title == "标志性成果") {
        type = "bzxcg";
      } else if (this.title == "思政课程与课程思政大格局") {
        type = "szhd";
      } else if (this.title == "团队建设") {
        type = "jstdjs";
      } else if (this.title == "培育品牌") {
        type = "pypp";
      } else if (this.title == "荣誉") {
        type = "ry";
      } else if (this.title == "基地活动") {
        type = "jdhd";
      } else if (this.title == "思政实践基地") {
        type = "szsjjd";
      } else if (this.title == "品牌活动") {
        type = "pphd";
      } else if (this.title == "品牌建设") {
        type = "ppjs";
      } else if (this.title == "品牌宣传") {
        type = "ppxc";
      } else if (this.title == "品牌效果") {
        type = "ppxg";
      } else if (this.title == "品牌基地") {
        type = "ppjd";
      } else if (this.title == "教研情况") {
        type = "teachingresearchsituation";
      } else if (this.title == "年度计划") {
        type = "ndjh";
      } else if (this.title == "思政育人") {
        type = "szyr";
      } else if (this.title == "品牌成果") {
        type = "ppcg";
      } else if (this.title == "科研情况") {
        type = "researchsituation";
      } else if (this.title == "思政微课") {
        type = "szwkmk";
      } else if (this.title == "项目被省级或国家级媒体报道次数") {
        type = "xxbsjhgjjmtbdcs";
      } else if (this.title == "省内外同类院校前来交流学习次数") {
        type = "snwtlyxqljlxxcs";
      }else if (this.title == "活动方案") {
        type = "hdfa";
      } else if (this.title == "思政微课团队成员") {
        type = "szwktdcy";
      }
      console.log(this.title);
      this.type = type;
      let data = {
        type: type,
        pageNo: this.pagination.current,
        pageSize: this.pagination.pageSize,
        applyId: this.id,
        sjId: this.dataid != null && this.dataid !== "" ? String(this.dataid) : "",
        code: this.code,
      };
      getAction("/lxbase/lxApplyEvidence/listEvidence", data).then((res) => {
        if (res.code === 200) {
          let data = res.result.records;
          if (data) {
            this.dataList = data;
            this.pagination.total = res.result.total;
          }
        }
        this.loading = false;
      });
    },
    closePreview() {
      this.$emit("closePreview");
    },
  },
};
</script>

<style scoped lang="scss">
.c-box {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow-y: auto;
  /*background: url("../../assets/images/img49.png") no-repeat;
  background-size: 100% 100%;*/
  .header-box {
    height: 60px;
    line-height: 60px;
    position: relative;
    text-align: center;
    background: #2155b5;
    /*border-top-left-radius: 15px;
	  border-top-right-radius: 15px;*/
    /*margin: 0px 19px 0px 9px;*/
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
  }
  .title-boxs,
  .title-box {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-bottom: 12px;
    font-size: 20px;
    margin-top: 30px;
  }
  .btn-action {
    width: 100px;
    height: 30px;
    border-radius: 6px;
    font-weight: 400;
    cursor: pointer;
    line-height: 30px;
    margin-right: 10px;
    text-align: center;
  }
  .nowrap {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .close-box {
    position: absolute;
    color: #fff;
    font-size: 24px;
    right: 3%;
    cursor: pointer;
    top: -2px;
  }
  .centent-box {
    /*margin: 0 12px 5px 0;*/
    padding: 10px 10px;
    height: 80%;
  }
  .img-box {
    width: 18px;
    height: 18px;
    margin-right: 9px;
  }
  .table-tr {
    width: 100%;
    display: inline-block;
    text-align: center;
    margin: 0 auto;
    // border-bottom: 1px solid #e8e8e8;
  }
  .table-content {
    margin: 0 auto;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
  }
  .preview-pop-box {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    .preview-box {
      margin: 50px auto;
      width: 1177px;
      height: 90%;
    }
    .preview-boxs {
      margin: 50px auto;
      width: 950px;
      height: 700px;
      overflow: hidden;
    }
    .preview-box-fullscreen {
      width: 100vw;
      height: 100vh;
    }
  }
}
</style>